import styled from 'styled-components';



export const FounderWrapper = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 3rem;
  align-items: center;

  p:first-of-type {
    text-align: left;
  }
    h4 {
      text-align: left;
      font-size: 1.3rem;
    }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    h4 {
      text-align: center;
    }
       p:first-of-type {
    text-align: center;
  }
  }
`;

export const FounderImage = styled.img`
  width: 350px;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

export const FounderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: ${(props) => props.theme.primary};
    margin-bottom: 0.5rem;

  }

  p {
    font-size: 1.1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;

export const FounderBottomText = styled.div`
  margin-top: 2rem;

  p {
    font-size: 1.1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
  }
`;

export const CoreValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const CoreValueItem = styled.div`
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  border-radius: 8px;
  text-align: center;
  padding: 2rem;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  h3 {
    font-size: 1.3rem;
    color: ${(props) => props.theme.secondary};
    margin-bottom: 1rem;
    font-weight: bold;
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
  }
`;
